<script>
import { Doughnut, mixins } from 'vue-chartjs'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  data() {
    return {
      //Chart.js options that control the appearance of the chart
      options: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI,

        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 85,
        tooltips: {
          enabled: false,
        },
        plugins: {
          datalabels: {
            formatter: (value) => {
              const result = value + '%'
              return value === 0 ? '' : result
            },
            font: {
              weight: 'normal',
              size: this.fontSize,
            },
            color: '#fff',
            display: false,
          },
        },
      },
    }
  },
  mixins: [reactiveProp],
  components: {
    ChartJSPluginDatalabels,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
}
</script>
